export default {
  // Top Bar
  company: 'KR Corp',
  recruit: 'Careers',
  news: 'News',
  familySite: 'Family Site',
  
  // Navigation
  company_menu: 'Company',
  business: 'Business',
  portfolio: 'Portfolio',
  insights: 'Insights',
  contact: 'Contact',
  
  // Hero
  hero_title: 'Your Optimal Partner',
  hero_subtitle: 'for Business Success',
  hero_description: 'Professional studio solutions from educational content production to live broadcasting',
  cta_consult: 'Free Consultation',
  cta_portfolio: 'View Portfolio',
  
  // Business Area
  business_title: 'Business Area',
  business_subtitle: '6 Core Business Areas',
  business_1_title: 'Educational Content',
  business_1_desc: 'High-quality e-learning and promotional videos',
  business_2_title: 'Live Broadcasting',
  business_2_desc: 'Stable webinar and event streaming',
  business_3_title: 'AI Solutions',
  business_3_desc: 'AI anchors and automatic subtitles',
  business_4_title: 'Studio Consulting',
  business_4_desc: 'Design, construction, and operation manuals',
  business_5_title: 'On-site Filming',
  business_5_desc: 'Nationwide filming and broadcasting support',
  business_6_title: 'Maintenance',
  business_6_desc: 'Annual contracts and quality management',
  
  // Portfolio
  portfolio_title: 'Success Stories',
  portfolio_projects: 'Total Projects',
  portfolio_delivery: 'On-time Delivery',
  portfolio_view_all: 'View All',
  portfolio_more: 'More Projects',
  
  // News
  news_title: 'KR Insights',
  news_view_all: 'View All',
  news_press: 'Press',
  news_blog: 'Blog',
  news_company: 'Company',
  
  // Partners
  partners_title: 'TRUSTED BY MARKET LEADERS',
  
  // Footer
  footer_tagline: 'Your optimal partner for business success',
  footer_services: 'Services',
  footer_company: 'Company',
  footer_contact: 'Contact',
  footer_about: 'About Us',
  footer_careers: 'Careers',
  footer_location: 'Location',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_corp: 'KR Studio Co., Ltd.',
  footer_ceo: 'CEO: Min-gyu Kim, In-guk Ryu',
  footer_rights: '© 2024 KR STUDIO. All rights reserved.',
  
  // Services
  service_content: 'Content Production',
  service_streaming: 'Live Streaming',
  service_consulting: 'Studio Consulting',
  service_lms: 'LMS Operation',
};